/** @jsx h */
import { h } from 'preact'
import Chevron from './icons/Chevron'

const BackFooter = props => {
  const { action } = props

  return (
    <div class='ClaimCard-footer--evidence'>
      <button
        class='ClaimCard-action ClaimCard-action--evidence'
        onClick={action}
        type='button'
      >
        <Chevron />
      </button>
    </div>
  )
}

export default BackFooter
